function BannerVideo() {
	this.build();
}

BannerVideo.prototype.build = function () {
	this.vid = document.querySelector('.banner-video video');
	if (this.vid) {
		this.vid.play();
	}
};
